/* Keep the top row visible while the secondary rows scroll away, without layout jumps. */
(() => {
  function init() {
    const header = document.querySelector('#header-component');
    if (!header || header.dataset.compactReady) return;
    const section = header.closest('.header-section');
    const top = header.querySelector('.header__row--top');
    if (!section || !top) return;
    header.dataset.compactReady = 'true';
    const measure = () => {
      const extra = Math.max(0, header.offsetHeight - top.offsetHeight);
      section.style.setProperty('--tdp-header-extra', `${extra}px`);
      document.documentElement.style.setProperty('--tdp-sticky-row-height', `${top.offsetHeight}px`);
    };
    new ResizeObserver(measure).observe(header);
    measure();
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
